export const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export const monthLabelKeys = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
export const monthNameKeys = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];

export const ASPNETCORE_IDENTITY_APPLICATION_COOKIE_NAME = ".AspNetCore.Identity.Application";
export const X_ACCESS_TOKEN_COOKIE_NAME = "X-Access-Token";
export const ALLOWED_COOKIE_PREFIXES = [ASPNETCORE_IDENTITY_APPLICATION_COOKIE_NAME, X_ACCESS_TOKEN_COOKIE_NAME];
export const NEXT_API_URLS = {
  session: "/api/auth/session",
  refresh: "/api/auth/refresh",
  logout: "/api/auth/logout",
} as const;
